export default __webpack_public_path__ + "static/media/facilities-img.2c3c0d48.png";